// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1mUH2","rotate":"_1DA88","dash":"_1cASg","color":"_39ka5"};